module.exports = __webpack_public_path__ + "img/Marina-Zurkow-Profile-Pic.465db5ba.png";